import { render, staticRenderFns } from "./DeleteFamilyHubAccount.vue?vue&type=template&id=6d6641b0&scoped=true"
import script from "./DeleteFamilyHubAccount.vue?vue&type=script&lang=js"
export * from "./DeleteFamilyHubAccount.vue?vue&type=script&lang=js"
import style0 from "./DeleteFamilyHubAccount.vue?vue&type=style&index=0&id=6d6641b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6641b0",
  null
  
)

export default component.exports